import { NOTIFY_MUTED_KEY, usePreferencesQuery } from '@shared/api/preferencesApi';

/** Notification types switched off in Settings: `workflow`, `queries`, `billing`, `payments`, `chat`. */
export type NotifyType = 'workflow' | 'queries' | 'billing' | 'payments' | 'chat';

export function useMutedNotifications(): NotifyType[] {
  const { data } = usePreferencesQuery(undefined);
  const value = data?.[NOTIFY_MUTED_KEY];
  return Array.isArray(value) ? value.filter((v): v is NotifyType => typeof v === 'string') : [];
}
